import { useTopicPageData, useTopicSupporterVoicesData } from '#src/app/pages/topic/details/pageContext';
import type { TopicPageSupporterVoice } from '#src/app/pages/topic/details/pageContext';

type Result = ModelHookResult<{
	shouldShowSupporterVoices: boolean;
	supporterVoices: readonly TopicPageSupporterVoice[];
	topicName: string;
	totalSupporterVoices: number;
}>;

export function useSupporterVoices(): Result {
	const {
		data: { name },
	} = useTopicPageData();

	const {
		data: { items, totalCount },
	} = useTopicSupporterVoicesData();

	return {
		data: {
			shouldShowSupporterVoices: items.length >= 3,
			supporterVoices: items,
			topicName: name,
			totalSupporterVoices: totalCount,
		},
	};
}
